// extracted by mini-css-extract-plugin
export default {"card":"I0-z","carouselContainer":"J0-z","carouselContent":"K0-z"};